export default __webpack_public_path__ + "static/media/829.848518d8.png";